export function isProfileComplete(profile) {
    return Boolean(
        profile?.firstName &&
        profile?.lastName &&
        profile?.designation &&
        profile?.dob &&
        profile?.states?.length > 0
    );
}
